import InlineSVG from "react-inlinesvg";
import type { PlanCardIcons } from "@sudowrite/shared-chat";

const iconClass = (extra?: string) => extra ?? "";

export const planCardWebIcons: PlanCardIcons = {
  chevronDown: (
    <InlineSVG
      src="/assets/chevron-down.svg"
      className="w-4 h-4 [&_path]:fill-app-grey-1"
      aria-hidden
    />
  ),
  planList: (
    <InlineSVG
      src="/assets/plan-list.svg"
      className="w-5 h-5 flex-shrink-0 [&_path]:fill-app-grey-1"
      aria-hidden
    />
  ),
  pencil: (
    <InlineSVG
      src="/assets/pencil.svg"
      className="w-[22px] h-[22px] [&_path]:fill-app-grey-1"
      aria-hidden
    />
  ),
  pause: (
    <InlineSVG
      src="/assets/pause.svg"
      className="w-[22px] h-[22px] [&_path]:fill-app-primary-cta-high-contrast"
      aria-hidden
    />
  ),
  play: (
    <InlineSVG
      src="/assets/play.svg"
      className="w-[22px] h-[22px] [&_path]:fill-app-primary-cta-high-contrast"
      aria-hidden
    />
  ),
  check: (
    <InlineSVG
      src="/assets/check.svg"
      className="w-[18px] h-[18px] [&_circle]:fill-app-primary-cta-high-contrast"
      aria-hidden
    />
  ),
  close: (
    <InlineSVG
      src="/assets/close.svg"
      className="w-[18px] h-[18px] [&_path]:fill-app-grey-1"
      aria-hidden
    />
  ),
  delete: (
    <InlineSVG
      src="/assets/delete.svg"
      className="w-5 h-5 [&_path]:fill-app-grey-1"
      aria-hidden
    />
  ),
  trashRestore: (
    <InlineSVG
      src="/assets/trash-restore.svg"
      className="w-5 h-5 [&_path]:fill-app-grey-1"
      aria-hidden
    />
  ),
  add: (
    <InlineSVG
      src="/assets/add.svg"
      className="w-5 h-5 [&_path]:fill-app-primary-cta-high-contrast"
      aria-hidden
    />
  ),
  send: (
    <InlineSVG
      src="/assets/send.svg"
      className="w-5 h-5 [&_path]:fill-app-cta-text-color"
      aria-hidden
    />
  ),
  loader: (
    <InlineSVG
      src="/assets/loader.svg"
      className="w-4 h-4 animate-spin [&_path]:fill-app-primary-cta-high-contrast"
      aria-hidden
    />
  ),
  lightning: (
    <InlineSVG
      src="/assets/lightning.svg"
      className="mr-1 h-4 w-4 [&_path]:fill-app-grey-1"
      aria-hidden
    />
  ),
};

export const planStepRowWebIcons = {
  chevronDown: planCardWebIcons.chevronDown,
  pause: (
    <InlineSVG
      src="/assets/pause.svg"
      className="w-6 h-6 [&_path]:fill-app-primary-cta-high-contrast"
      aria-hidden
    />
  ),
  loader: (
    <InlineSVG
      src="/assets/loader.svg"
      className="w-5 h-5 animate-spin [&_path]:fill-app-primary-cta-high-contrast"
      aria-hidden
    />
  ),
  close: planCardWebIcons.close,
  delete: planCardWebIcons.delete,
  trashRestore: planCardWebIcons.trashRestore,
};

export const commentingCardWebIcons = {
  chevronDown: planCardWebIcons.chevronDown,
  comment: (
    <InlineSVG
      src="/assets/comment-icon.svg"
      className="w-5 h-5 flex-shrink-0 [&_path]:fill-app-grey-1"
      aria-hidden
    />
  ),
  stop: (
    <InlineSVG
      src="/assets/stop-square.svg"
      className="w-[22px] h-[22px] [&_path]:fill-app-primary-cta-high-contrast"
      aria-hidden
    />
  ),
};

export const storyBibleCardWebIcons = {
  stop: commentingCardWebIcons.stop,
  chevronRight: (
    <InlineSVG
      src="/assets/chevron-right.svg"
      className="w-4 h-4 flex-shrink-0 [&_path]:fill-app-grey-1"
      aria-hidden
    />
  ),
  frame: (
    <InlineSVG
      src="/assets/story-bible-cta-card-frame.svg"
      className="w-full h-full"
      aria-hidden
    />
  ),
};

export function storyBibleSectionWebIcon(iconSrc: string) {
  return (
    <InlineSVG
      src={iconSrc}
      className={iconClass("w-5 h-5 max-w-[22px] max-h-[18px] [&_path]:fill-[#ACACAC]")}
      aria-hidden
    />
  );
}
